/** @format */

import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { HmfGlobalChipsComponent } from '@dsg-tech/homefield-angular';
import { ShippingOption } from '@plp/data-access/constants';

@Component({
  selector: 'plp-components-shipping-option-button',
  imports: [HmfGlobalChipsComponent],
  templateUrl: './shipping-option-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShippingOptionButtonComponent {
  readonly shippingOption = input<ShippingOption>();
  readonly selected = input(false);
  readonly isMobile = input(false);
  readonly disabled = input<boolean>();
  readonly count = input(0);
  readonly fulfillmentFacetsEnabled = input<boolean>(false);
  readonly hasFulfillmentData = input<boolean>(false);

  readonly selectedOption = output<void>();
  readonly id = input<string>();

  readonly isLoading = computed(
    () => this.fulfillmentFacetsEnabled() && !this.hasFulfillmentData(),
  );

  readonly isDisabled = computed(
    () =>
      this.disabled() ||
      this.isLoading() ||
      (this.fulfillmentFacetsEnabled() && this.hasFulfillmentData() && this.count() === 0),
  );

  readonly label = computed(() => {
    if (this.fulfillmentFacetsEnabled()) {
      const count = this.isLoading() ? '00' : this.count().toLocaleString('en-US');
      return `${this.shippingOptionLabel()} (${count})`;
    }

    return this.shippingOptionLabel();
  });

  emitSelectedOption() {
    this.selectedOption.emit();
  }

  private shippingOptionLabel(): string {
    return this.shippingOption()?.label ?? '';
  }
}
